import React from "react";
import Skeleton from "react-loading-skeleton";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentExam } from "store/ExamStore/selectors";
import { selectRegionInfo } from "store/PatientStore/selectors";

type Props = {
  loading?: boolean;
};
export const PatientTopSection = ({ loading }: Props) => {
  const exam = useAppSelector(selectCurrentExam);
  const regionInfo = useAppSelector(selectRegionInfo)(exam.patientRegionId);
  return (
    <section className="flex flex-wrap items-center justify-between pb-3 border-b border-b-[#E1E1E1]">
      <div className="flex flex-col">
        <h1>Video Review</h1>
        {loading ? (
          <>
            <Skeleton count={1} height={30} />
          </>
        ) : (
          <h2 className="text-xl font-normal text-grayDark leading-[39px] capitalize">
            {regionInfo.movement} | {regionInfo.side} {regionInfo.jointName} | {regionInfo.movementTitle}
          </h2>
        )}
      </div>
    </section>
  );
};
